import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from './Button';
import chainPropTypes from './chainPropTypes';

/**
 * IconButton
 * */
const IconButton = React.forwardRef(function IconButton(props, ref) {
  const { children, classes, className, color, disabled, prefixCls, ...other } = props;

  return (
    <Button className={classNames(prefixCls, className)} disabled={disabled} ref={ref} {...other}>
      {children}
    </Button>
  );
});

IconButton.propTypes = {
  /**
   *  icon元素
   */
  children: chainPropTypes(PropTypes.node, props => {
    const found = React.Children.toArray(props.children).some(
      child => React.isValidElement(child) && child.props.onClick,
    );

    if (found) {
      return new Error(
        [
          'NeatUI: 你正试图给button的子元素添加点击事件回调。',
          'Firefox 将不会触发该事件',
          'https://github.com/mui-org/material-ui/issues/13957',
        ].join('\n'),
      );
    }

    return null;
  }),
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * 是否禁用.
   */
  disabled: PropTypes.bool,
};

IconButton.defaultProps = {
  prefixCls: 'ne-icon-button',
  disabled: false,
};

export default IconButton;



// WEBPACK FOOTER //
// ./src/button/IconButton.jsx